export function hqNextAction({
  completed,
  handler,
  phase,
  ongoing,
  firstDoors,
}: {
  completed: number | null;
  handler?: string | null;
  phase?: string;
  ongoing: boolean;
  firstDoors: boolean;
}) {
  if (completed === null)
    return { label: "Loading your progress…", step: null };
  if (completed >= 7) return { label: "View your promotion", step: "Debrief" };
  if (phase === "accepted" || (completed < 3 && ongoing))
    return { label: "Continue your mission", step: "Delivered" };
  if (completed >= 3)
    return {
      label: !handler
        ? "Meet your handler"
        : phase === "review" || phase === "discover"
          ? "Continue with your handler"
          : "Do another mission",
      step: "Handlers",
    };
  return {
    label: completed === 0 ? "Start your first mission" : "Do another mission",
    step: completed === 0 && firstDoors ? "First doors" : "Doors",
  };
}
